import React, { useEffect } from "react";
import numberToWord from "../../components/common/utlity/invoiceword";
import { useTranslation } from "react-i18next";
import { Country, State } from "country-state-city";
import { truncateCommaSeparatedString } from "../../components/common/utlity/utility";
import { AWS_URL } from "../../services/http.service";
import { getCurrencySymbol } from "../../components/common/utlity/options";
import { momentDateFormat } from "../../components/common/utlity/utility";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryData } from "../../store/actions/action";
import { useNavigate, useParams } from "react-router-dom";
const formatCurrency = (val, currency) => {
  console.log("LINE NO 12", val);
  let num = 0;

  if (typeof val === "number") {
    num = val;
  } else if (typeof val === "string") {
    num = parseFloat(val);
    if (isNaN(num)) num = 0; // fallback if string is not numeric
  }

  return `${getCurrencySymbol(currency)} ${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatDate = (str) => {
  if (!str) return "-";
  const date = new Date(str);
  if (isNaN(date)) return str;
  return date.toLocaleDateString();
};

const DoubleDevine = ({
  item,
  containerRef,
  businessName,
  phone,
  darkMode = false,
  bussiness,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const Product = useSelector((state) => state?.inventory.products.data);
  const { bussinessUuid } = useParams();
  useEffect(() => {
    if (!Product || (Array.isArray(Product) && Product.length === 0)) {
      dispatch(getInventoryData(bussinessUuid));
    }
  }, [dispatch, Product, bussiness?.bussinessUuid]);

  if (!item) return <div>No invoice data available</div>;
  const country = Country.getCountryByCode(bussiness?.country);
  const state = State.getStateByCodeAndCountry(
    bussiness?.state,
    bussiness?.country
  );
  const itemCountry = Country.getCountryByCode(item?.country);
  const itemState = State.getStateByCodeAndCountry(item?.state, item?.country);

  // Compute totals dynamically
  const itemsToUse = item?.invoiceId?.startsWith("RT")
    ? item?.returnitems
    : item?.items;

  // Enrich items with raw materials data if manufactured
  const enrichedItems =
    itemsToUse?.map((itm) => {
      if (itm.productCategory === "Manufactured" && itm.productId && Product) {
        const foundProduct = Array.isArray(Product)
          ? Product.find((p) => p.productId === itm.productId)
          : Product[itm.productId];
        if (foundProduct) {
          return {
            ...itm,
            rawMaterialsUsed: foundProduct.rawMaterialsUsed || [],
            totalRawMaterialCost: foundProduct.totalRawMaterialCost || 0,
            manufacturingSource: foundProduct.manufacturingSource || null,
          };
        }
      }
      return itm;
    }) || [];

  const totalQuantity =
    enrichedItems?.reduce((sum, i) => sum + (Number(i.quantity) || 0), 0) || 0;
  const totalGST =
    enrichedItems?.reduce(
      (sum, i) =>
        sum + ((i.salePrice || 0) * (i.quantity || 0) * (i.igst || 0)) / 100,
      0
    ) || 0;
  const totalAmount =
    enrichedItems?.reduce((sum, i) => sum + (Number(i.finalPrice) || 0), 0) ||
    0;

  const amountInwords = numberToWord(totalAmount);

  console.log("line no 70", totalAmount);
  // Calculate paid amount and remaining balance
  const paidAmount =
    (parseFloat(item.transactionAmount) || 0) -
    (parseFloat(item.remainingTransactionAmount) || 0);
  const remainingBalance = item.remainingTransactionAmount || 0;

  // Additional calculations
  const totalAdditionalDiscount = Array.isArray(item.additionalDiscount)
    ? item.additionalDiscount.reduce(
        (sum, d) => sum + (parseFloat(d.amount) || 0),
        0
      )
    : 0;

  const totalAdditionalFee = Array.isArray(item.additionalFee)
    ? item.additionalFee.reduce(
        (sum, d) => sum + (parseFloat(d.amount) || 0),
        0
      )
    : 0;

  const totalInvoiceAmount = enrichedItems?.reduce((sum, item) => {
    return sum + parseFloat(item?.finalPrice || 0);
  }, 0);

  // Filter manufactured items for BOM section
  const manufacturedItems =
    enrichedItems?.filter((itm) => itm.productCategory === "Manufactured") ||
    [];

  return (
    <div
      ref={containerRef}
      className={`max-w-4xl mx-auto p-6 rounded-lg shadow-sm ${
        darkMode ? "dark:bg-[#020617] text-white" : "bg-white"
      }`}
    >
      {/* Header with curved design */}
      <div className='flex items-stretch h-28 -mx-6 -mt-6 mb-6 overflow-hidden'>
        {/* Gray section */}
        <div className='relative flex-1 bg-gray-800 flex items-center px-6'>
          <div className='flex items-center'>
            {/* Logo */}
            <div className='w-12 h-12 mr-3 rounded-full overflow-hidden flex items-center justify-center bg-gray-100 shadow'>
              <img
                src={
                  bussiness?.businesslogo
                    ? AWS_URL + bussiness.businesslogo
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                }
                alt='Business Logo'
                className='object-contain w-full h-full'
                // crossOrigin='anonymous'
              />
            </div>

            {/* Name + GST stacked */}
            <div className='flex flex-col'>
              <h1 className='text-white text-2xl font-normal'>
                {businessName || "Business Name"}
              </h1>
              <p className='text-white text-xs'>
                GSTIN: {bussiness.gstNumber || "N/A"}
              </p>
              <p className='text-white text-xs'>
                Email: {bussiness?.email || "N/A"}
              </p>
              <p className='text-xs text-white'>
                Address:
                {`${bussiness.firstLine},${state?.name},${country?.name}
              ` || "N/A"}
              </p>
            </div>
          </div>

          {/* Curved intersection */}
          <div className='absolute -right-10 top-0 h-full w-20'>
            <div className='relative h-full w-full'>
              {/* Top red curve */}
              <div className='absolute top-0 right-0 h-1/2 w-full bg-red-500 rounded-bl-full'></div>
              {/* Bottom gray curve */}
              <div className='absolute bottom-0 left-0 h-1/2 w-full bg-gray-800 rounded-tr-full'></div>
            </div>
          </div>
        </div>

        {/* Red section */}
        <div
          className='relative flex-1 bg-red-500 flex items-center pr-12'
          style={{ height: "50%" }}
        >
          <div className='flex items-center text-white ml-auto'>
            <svg
              className='w-5 h-5 mr-2'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
              />
            </svg>
            <span className='text-m'>{phone || "0000000000"}</span>
          </div>
        </div>
      </div>

      {/* Bill To Section */}
      <div className='mb-6'>
        <h2
          className={`text-3xl font-normal ${
            darkMode ? "text-white" : "text-gray-800"
          }`}
        >
          {t("NEWINVOICE.TAX_INVOICE")}
        </h2>

        <div className='flex justify-between'>
          <div>
            <h2
              className={`text-xl font-semibold mb-2 flex items-center gap-2 ${
                darkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              {t("NEWINVOICE.BILL_TO")}:{" "}
              <span className={darkMode ? "text-white" : "text-gray-800"}>
                {item.customerName || "-"}
              </span>
            </h2>

            <p className={darkMode ? "text-white" : "text-gray-600"}>
              <span className='font-medium'>{t("NEWINVOICE.CONTACT_NO")}:</span>{" "}
              {item.mobile || "-"}
            </p>
            <p
              className={`${
                darkMode ? "text-gray-300" : "text-gray-600"
              } text-xs`}
            >
              {`${item.address} ,${itemState?.name},${itemCountry?.name}` ||
                "N/A"}
            </p>
          </div>
          <div className='text-right'>
            <p
              className={
                darkMode
                  ? "text-white font-semibold"
                  : "text-gray-700 font-semibold"
              }
            >
              {t("NEWINVOICE.NO")}: {item.invoiceId || "-"}
            </p>
            <p className={darkMode ? "text-white" : "text-gray-700"}>
              {t("NEWINVOICE.DATE")}: {formatDate(item.saleDate)}
            </p>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <div className='mb-6 overflow-x-auto'>
        <table className='min-w-full border-collapse border border-gray-300 rounded-lg text-sm'>
          <thead>
            <tr className='text-white'>
              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-left font-medium rounded-tl-lg'>
                #
              </th>
              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-left font-medium'>
                {t("NEWINVOICE.ITEM_NAME")}
              </th>
              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-left font-medium'>
                {t("NEWINVOICE.HSN_SAC")}
              </th>
              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-center font-medium'>
                {t("NEWINVOICE.QTY")}
              </th>
              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                {t("NEWINVOICE.PRICE_PER_UNIT")}
              </th>
              {item.intraState === true ? (
                <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                  IGST
                </th>
              ) : (
                <>
                  <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                    CGST
                  </th>
                  <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                    SGST
                  </th>
                </>
              )}

              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                CESS
              </th>

              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium'>
                {t("NEWINVOICE.DISCOUNT")}
              </th>

              <th className='py-1 px-3 bg-red-500 border border-gray-300 text-right font-medium rounded-tr-lg'>
                {t("NEWINVOICE.AMOUNT")}
              </th>
            </tr>
          </thead>
          <tbody>
            {enrichedItems?.map((itm, idx) => {
              return (
                <tr
                  key={idx}
                  className={`
            ${
              idx % 2 === 0
                ? darkMode
                  ? "dark:bg-[#170f2a]"
                  : "bg-white"
                : darkMode
                ? "dark:bg-[#170f2a]"
                : "bg-gray-50"
            }
          `}
                >
                  <td
                    className={`py-1 px-3 border border-gray-300 text-center ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {idx + 1}
                  </td>
                  <td
                    className={`py-1 px-3 border border-gray-300 font-semibold ${
                      darkMode ? "text-white" : "text-gray-600"
                    }`}
                  >
                    {itm.productName || itm.description || "-"}
                  </td>
                  <td
                    className={`py-1 px-3 border border-gray-300 ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {truncateCommaSeparatedString(itm.hsnNumber) ||
                      itm.hsn ||
                      "N/A"}
                  </td>
                  <td
                    className={`py-1 px-3 border border-gray-300 text-center ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {itm.quantity || 0}
                  </td>
                  <td
                    className={`py-1 px-3 border border-gray-300 text-right ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {formatCurrency(itm.salePrice, bussiness?.currency)}
                  </td>
                  {item.intraState === true ? (
                    <td
                      className={`py-1 px-3 border border-gray-300 text-right ${
                        darkMode ? "text-gray-300" : "text-gray-600"
                      }`}
                    >
                      <>
                        <div className='text-xss'>({itm.igst} %)</div>
                        <div>
                          {`${(itm.salePrice * (itm.igst / 100)).toFixed(2)}` ||
                            0}{" "}
                          ₹
                        </div>
                      </>
                    </td>
                  ) : (
                    <>
                      <td
                        className={`py-1  border border-gray-300  ${
                          darkMode ? "text-gray-300" : "text-gray-600"
                        }`}
                      >
                        <>
                          <div className='text-xss'>({itm.cgst} %)</div>
                          <div>
                            {`${(itm.salePrice * (itm.cgst / 100)).toFixed(
                              2
                            )}` || 0}{" "}
                            ₹
                          </div>
                        </>
                      </td>

                      <td
                        className={`py-1 border border-gray-300 ${
                          darkMode ? "text-gray-300" : "text-gray-600"
                        }`}
                      >
                        {/* ({itm.sgst_utgst || 0}%) */}
                        <>
                          <div className='text-xss'>({itm.sgst_utgst} %)</div>
                          <div>
                            {`${(
                              itm.salePrice *
                              (itm.sgst_utgst / 100)
                            ).toFixed(2)}` || 0}{" "}
                            ₹
                          </div>
                        </>
                      </td>
                    </>
                  )}

                  <td
                    className={`py-1 border border-gray-300  ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {/* ({itm.cess || 0}%) */}
                    <>
                      <div className='text-xss'>({itm.cess} %)</div>
                      <div>
                        {`${(itm.salePrice * (itm.cess / 100)).toFixed(2)}` ||
                          0}{" "}
                        ₹
                      </div>
                    </>
                  </td>

                  <td
                    className={`py-1 px-3 border border-gray-300 text-right ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    <>
                      <div className='text-xss'>
                        ({itm.discount || 0} {itm.discountUnit || "%"})
                      </div>
                      <div>
                        {(itm.discountUnit === "%"
                          ? (itm.salePrice * (Number(itm.discount) || 0)) / 100 // % discount
                          : Number(itm.discount) || 0
                        ) // flat discount
                          .toFixed(2)}{" "}
                        ₹
                      </div>
                    </>
                  </td>
                  <td
                    className={`py-1 px-3 border border-gray-300 text-right ${
                      darkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {formatCurrency(itm.finalPrice, bussiness?.currency)}
                  </td>
                </tr>
              );
            })}

            {/* Totals Row */}
            <tr
              className={`font-semibold ${
                darkMode
                  ? "dark:bg-[#170f2a] text-white"
                  : "bg-gray-50 text-gray-700"
              }`}
            >
              <td className='py-1 px-3 border border-gray-300 rounded-bl-lg'></td>
              <td className='py-1 px-3 border border-gray-300'>
                {t("NEWINVOICE.TOTAL")}
              </td>
              <td className='py-1 px-3 border border-gray-300'></td>
              <td className='py-1 px-3 border border-gray-300 text-center'>
                {totalQuantity}
              </td>
              <td className='py-1 px-3 border border-gray-300'></td>
              <td className='py-1 px-3 border border-gray-300'></td>
              {item.intraState === true ? (
                <td className='py-1 px-3 border border-gray-300'></td>
              ) : (
                <>
                  <td className='py-1 px-3 border border-gray-300'></td>

                  <td className='py-1 px-3 border border-gray-300'></td>
                </>
              )}
              <td className='py-1 px-3 border border-gray-300'></td>
              {/* {formatCurrency(totalGST, bussiness?.currency)} */}
              <td className='py-1 px-3 border border-gray-300 rounded-br-lg'>
                {formatCurrency(totalAmount, bussiness?.currency)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Bill of Materials Section - Only show if there are manufactured items */}
      {manufacturedItems.length > 0 && (
        <div className='mb-6 overflow-x-auto'>
          <h3
            className={`text-lg font-semibold mb-2 ${
              darkMode ? "text-white" : "text-gray-800"
            }`}
          >
            Bill of Materials
          </h3>
          {manufacturedItems.map((manufacturedItem, mIdx) => (
            <div key={mIdx} className='mb-4'>
              <h4
                className={`font-medium mb-2 ${
                  darkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                For: {manufacturedItem.productName} (Qty:{" "}
                {manufacturedItem.quantity})
              </h4>
              {manufacturedItem.rawMaterialsUsed &&
              manufacturedItem.rawMaterialsUsed.length > 0 ? (
                <table className='min-w-full border-collapse border border-gray-300 rounded-lg text-sm'>
                  <thead>
                    <tr className='text-white bg-gray-700'>
                      <th className='py-1 px-3 border border-gray-300 text-left font-medium'>
                        Raw Material
                      </th>
                      <th className='py-1 px-3 border border-gray-300 text-center font-medium'>
                        Quantity
                      </th>
                      <th className='py-1 px-3 border border-gray-300 text-center font-medium'>
                        Unit
                      </th>
                      <th className='py-1 px-3 border border-gray-300 text-right font-medium'>
                        Cost per Unit
                      </th>
                      <th className='py-1 px-3 border border-gray-300 text-right font-medium'>
                        Total Cost
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {manufacturedItem.rawMaterialsUsed.map((rm, rmIdx) => (
                      <tr
                        key={rmIdx}
                        className={`
                        ${
                          rmIdx % 2 === 0
                            ? darkMode
                              ? "dark:bg-[#170f2a]"
                              : "bg-white"
                            : darkMode
                            ? "dark:bg-[#170f2a]"
                            : "bg-gray-50"
                        }
                      `}
                      >
                        <td
                          className={`py-1 px-3 border border-gray-300 ${
                            darkMode ? "text-gray-300" : "text-gray-600"
                          }`}
                        >
                          {rm.rawMaterialName}
                        </td>
                        <td
                          className={`py-1 px-3 border border-gray-300 text-center ${
                            darkMode ? "text-gray-300" : "text-gray-600"
                          }`}
                        >
                          {rm.quantityUsed}
                        </td>
                        <td
                          className={`py-1 px-3 border border-gray-300 text-center ${
                            darkMode ? "text-gray-300" : "text-gray-600"
                          }`}
                        >
                          {rm.unitSize}
                        </td>
                        <td
                          className={`py-1 px-3 border border-gray-300 text-right ${
                            darkMode ? "text-gray-300" : "text-gray-600"
                          }`}
                        >
                          {formatCurrency(rm.costPerUnit, bussiness?.currency)}
                        </td>
                        <td
                          className={`py-1 px-3 border border-gray-300 text-right ${
                            darkMode ? "text-gray-300" : "text-gray-600"
                          }`}
                        >
                          {formatCurrency(rm.totalCost, bussiness?.currency)}
                        </td>
                      </tr>
                    ))}
                    {manufacturedItem.rawMaterialsUsed.length > 0 && (
                      <tr
                        className={`font-semibold ${
                          darkMode
                            ? "dark:bg-[#170f2a] text-white"
                            : "bg-gray-50 text-gray-700"
                        }`}
                      >
                        <td
                          className='py-1 px-3 border border-gray-300'
                          colSpan={3}
                        >
                          Total Raw Material Cost
                        </td>
                        <td className='py-1 px-3 border border-gray-300'></td>
                        <td className='py-1 px-3 border border-gray-300 text-right'>
                          {formatCurrency(
                            manufacturedItem.totalRawMaterialCost ||
                              manufacturedItem.rawMaterialsUsed.reduce(
                                (sum, rm) => sum + rm.totalCost,
                                0
                              ),
                            bussiness?.currency
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <p className={darkMode ? "text-gray-400" : "text-gray-600"}>
                  No raw materials data available.
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Delivery/Pickup Information */}
      <div className='mb-4'>
        {item.saleType === "homeDelivery" && (
          <div className='flex justify-between'>
            <div className={darkMode ? "text-white" : "text-gray-700"}>
              <span className='font-semibold'>
                {t("SIDER.EXPECTED_DELIVERY")}:
              </span>
              <span>
                {" "}
                {momentDateFormat(item.deliveryPreference?.deliveryDate)}
              </span>
            </div>
          </div>
        )}

        {item.saleType === "shedulePickup" && item.pickupDate && (
          <div className='flex justify-between'>
            <div className={darkMode ? "text-white" : "text-gray-700"}>
              <span className='font-semibold'>{t("SIDER.PICKUP_DATE")}:</span>
              <span> {momentDateFormat(item.pickupDate)}</span>
            </div>
            <div className={darkMode ? "text-white" : "text-gray-700"}>
              <span className='font-semibold'>{t("SIDER.PICKUP_TIME")}:</span>
              <span> {item.pickupTime}</span>
            </div>
          </div>
        )}
      </div>

      {/* Tax Information */}
      {/* <div className='mb-4'>
        {item.intraState === true ? (
          <div className={darkMode ? "text-white" : "text-gray-700"}>
            <span className='font-semibold'>{t("TAX_WITHOUT_PERC.IGST")}:</span>
            <span> {item.igst || 0}</span>
          </div>
        ) : (
          <div className='flex justify-between'>
            <div className={darkMode ? "text-white" : "text-gray-700"}>
              <span className='font-semibold'>
                {t("TAX_WITHOUT_PERC.CGST")}:
              </span>
              <span> {item.cgst || 0}</span>
            </div>
            <div className={darkMode ? "text-white" : "text-gray-700"}>
              <span className='font-semibold'>
                {t("TAX_WITHOUT_PERC.SGST")}:
              </span>
              <span> {item.sgst || 0}</span>
            </div>
          </div>
        )}

        {item.cess && (
          <div className={darkMode ? "text-white" : "text-gray-700"}>
            <span className='font-semibold'>{t("TAX_WITHOUT_PERC.CESS")}:</span>
            <span> {item.cess}</span>
          </div>
        )}
      </div> */}

      {/* Summary Table */}
      <div className='grid grid-cols-3 gap-2'>
        <div className='col-span-2'>
          <div className='border-t border-gray-300 pt-4'>
            {/* Amount in Words */}
            <div className='mb-4'>
              <h3
                className={`text-lg font-semibold ${
                  darkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                {t("NEWINVOICE.AMOUNT_IN_WORDS")}
              </h3>
              <p
                className={
                  darkMode ? "text-gray-400 italic" : "text-gray-600 italic"
                }
              >
                {amountInwords}
              </p>
            </div>

            {/* Notes */}
            {item.notes && (
              <div className='mb-4'>
                <h3
                  className={`text-lg font-semibold ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Notes
                </h3>
                <p className={darkMode ? "text-gray-400" : "text-gray-600"}>
                  {item.notes}
                </p>
              </div>
            )}

            {/* Footer */}
            <div className='flex justify-between items-end'>
              <div>
                <p className={darkMode ? "text-gray-400" : "text-gray-600"}>
                  {t("NEWINVOICE.FOR_COMPANY")}:-
                  {bussiness.businessName}
                </p>
                <p className={darkMode ? "text-gray-400" : "text-gray-600"}>
                  {item.authorizedPerson || ""}
                </p>
              </div>
            </div>
          </div>
          {bussiness?.aadharPhoto && (
            <div
              class='flex  p-4 bg-gray-100 rounded-lg'
              style={{ width: "35%" }}
            >
              <img
                src={AWS_URL + bussiness?.aadharPhoto}
                alt='Payment QR Code'
                class='w-30 object-contain'
                // crossOrigin='anonymous'
              />
            </div>
          )}
        </div>
        <div className='col-span-1'>
          <div className='mb-6 max-w-xs ml-auto'>
            <table className='w-full border-collapse border border-gray-300 text-sm'>
              <tbody>
                <tr>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-600"
                    } font-medium`}
                  >
                    {t("NEWINVOICE.SUB_TOTAL")}
                  </td>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-600"
                    }`}
                  >
                    {formatCurrency(totalAmount, bussiness?.currency)}
                  </td>
                </tr>

                {/* Additional Fee */}
                {totalAdditionalFee > 0 && (
                  <tr>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-700"
                      } font-medium`}
                    >
                      {t("INVOICE.ADDITIONAL_FEE")}
                    </td>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-600"
                      }`}
                    >
                      +{formatCurrency(totalAdditionalFee, bussiness?.currency)}
                    </td>
                  </tr>
                )}

                {/* Additional Discount */}
                {totalAdditionalDiscount > 0 && (
                  <tr>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-700"
                      } font-medium`}
                    >
                      {t("INVOICE.ADDITIONAL_DISCOUNT")}
                    </td>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-600"
                      }`}
                    >
                      -
                      {formatCurrency(
                        totalAdditionalDiscount,
                        bussiness?.currency
                      )}
                    </td>
                  </tr>
                )}

                {/* Subscription Discount */}
                {item.subscriptionDisc > 0 && (
                  <tr>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-700"
                      } font-medium`}
                    >
                      {t("INVOICE.SUBSCRIPTION_SAVINGS")}
                    </td>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-600"
                      }`}
                    >
                      -
                      {formatCurrency(
                        item.subscriptionDisc,
                        bussiness?.currency
                      )}
                    </td>
                  </tr>
                )}

                {/* Calculate the correct total amount */}
                {(() => {
                  // Calculate the correct total
                  const calculatedTotal =
                    totalAmount -
                    totalAdditionalDiscount +
                    totalAdditionalFee -
                    (item.subscriptionDisc || 0);

                  return (
                    <tr
                      className={`border-t-2 bg-red-500 border-gray-300 font-bold ${
                        darkMode ? "text-white" : "text-gray-800"
                      }`}
                    >
                      <td className='py-1 px-3 border border-gray-300'>
                        {t("COMMON.TOTAL_AMOUNT")}
                      </td>
                      <td className='py-1 px-3 border border-gray-300'>
                        {formatCurrency(calculatedTotal, bussiness?.currency)}
                      </td>
                    </tr>
                  );
                })()}

                {/* Advance Payment */}
                {(item.saleType === "advancePayment" ||
                  item.saleType === "advanceSale") && (
                  <tr>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-700"
                      } font-medium`}
                    >
                      Advance Amount
                    </td>
                    <td
                      className={`py-1 px-3 border ${
                        darkMode
                          ? "border-gray-300 text-gray-300"
                          : "border-gray-300 text-gray-600"
                      }`}
                    >
                      {formatCurrency(item.advancePayment, bussiness?.currency)}
                    </td>
                  </tr>
                )}
                {/* Payment Mode */}
                <tr>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-700"
                    } font-medium`}
                  >
                    {t("NEWINVOICE.PAYMENT_MODE")}
                  </td>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-600"
                    }`}
                  >
                    {item.paymentMode || "-"}
                  </td>
                </tr>
                {/* Remaining Balance or Total Value */}
                <tr>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-700"
                    } font-medium`}
                  >
                    {item.saleType === "advancePayment"
                      ? "Remaining Balance"
                      : t("COMMON.TOTAL_VALUE")}
                  </td>
                  <td
                    className={`py-1 px-3 border ${
                      darkMode
                        ? "border-gray-300 text-gray-300"
                        : "border-gray-300 text-gray-600"
                    }`}
                  >
                    {item.invoiceId?.startsWith("RT")
                      ? formatCurrency(
                          item.totalReturnAmount,
                          bussiness?.currency
                        )
                      : formatCurrency(
                          totalAmount -
                            totalAdditionalDiscount +
                            totalAdditionalFee -
                            (item.subscriptionDisc || 0) -
                            parseFloat(item.advancePayment || 0),
                          bussiness?.currency
                        )}
                  </td>
                </tr>

                {/* Paid and Due Balances */}
                {item.remainingTransactionAmount > 0 && (
                  <>
                    <tr>
                      <td
                        className={`py-1 px-3 border ${
                          darkMode
                            ? "border-gray-300 text-gray-300"
                            : "border-gray-300 text-gray-700"
                        } font-medium`}
                      >
                        {t("NEWINVOICE.RECEIVED")}
                      </td>
                      <td
                        className={`py-1 px-3 border ${
                          darkMode
                            ? "border-gray-300 text-gray-300"
                            : "border-gray-300 text-gray-600"
                        }`}
                      >
                        {formatCurrency(paidAmount, bussiness?.currency)}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className={`py-1 px-3 border ${
                          darkMode
                            ? "border-gray-300 text-gray-300"
                            : "border-gray-300 text-gray-700"
                        } font-bold`}
                      >
                        {t("Due Balance")}
                      </td>
                      <td
                        className={`py-1 px-3 border ${
                          darkMode
                            ? "border-gray-300 text-gray-300"
                            : "border-gray-300 text-gray-600"
                        } font-bold`}
                      >
                        {formatCurrency(remainingBalance, bussiness?.currency)}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
            <div className='text-right mt-20'>
              <p
                className={
                  darkMode
                    ? "text-gray-300 font-medium"
                    : "text-gray-700 font-medium"
                }
              >
                {/* {t("NEWINVOICE.AUTHORIZED_SIGNATORY")} */}
                Authorised Signature
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleDevine;
